import { frontendURL } from '../../../../helper/URLHelper';
import SchoolsSettings from './SchoolsSettings.vue';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/schools'),
            name: 'schools_settings',
            component: SchoolsSettings,
            meta: {
                permissions: ['administrator'],
            },
        },
    ],
};
